export const styles = {
  productWraper: {
    display: 'flex',
    flexWrap: 'wrap'
  }
}



// WEBPACK FOOTER //
// ./src/pages/HeroLocations/styles.js